/** Compatibility export; the business domain owns this implementation. */
export { EnumFlyingDesignStatus, FLYING_DESIGN_TAG_LIMITATIONS, FlyingDesignListingSchema, FlyingDesignSchema, IFlyingDesign, IFlyingDesignListing, IFlyingDesignStatus } from '@domains/upload/shared';
